import { useauthMeQuery } from '@/types/generated/graphql';
import { useLogout } from '@shared/hooks/use-logout';
import { useModal } from '@shared/hooks/use-modal';

export function useProfile() {
  const { appLogout, loading } = useLogout();
  const { open, handleOpen, handleClose } = useModal();

  const { data: userProfile } = useauthMeQuery();
  const { name: userName, email, id: loggedInUserId } = userProfile?.authMe?.data?.user || {};
  const profileUrl = userProfile?.authMe?.data?.user?.profilePicture?.url;
  const userRole = userProfile?.authMe?.data?.userWorkspaceRole?.[0]?.role?.label;

  return {
    userName,
    loggedInUserId,
    email: email ?? '',
    profileUrl,
    loading,
    handleLogout: appLogout,
    userRole,
    logoutOpen: open,
    logoutHandleOpen: handleOpen,
    logoutHandleClose: handleClose,
  };
}
